import Immutable from 'seamless-immutable';
import { normalize } from 'normalizr';

import firebase from '../firebase';
import schema from '../schema';

const ActionTypes = {
  RECEIVED_MARKET_DATA: 'RECEIVED_MARKET_DATA',
};

const Actions = {
  creators: {
    dataMarkets: data => ({
      data,
      type: ActionTypes.RECEIVED_MARKET_DATA,
    }),
  },
  thunks: {
    fetchMarkets: () => dispatch => {
      const ref = firebase.database().ref('markets');
      ref.once('value', data => {
        const markets = schema.marketsHelper(data.val());
        const d = normalize(markets, schema.MARKETS);
        dispatch(Actions.creators.dataMarkets(d));
      });
    },
  },
};

export { Actions };

const defaultState = Immutable({});
export default (state = defaultState, action) => {
  // console.log(action);
  if (action.type === ActionTypes.RECEIVED_MARKET_DATA) {
    return state.merge(action.data.entities.markets);
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/ducks/markets.js